import {js2xml} from 'xml-js';
import {
    getConnection,
    getCurSession,
    getStatusID,
    setIsBPMChanged
} from '../../../../../_shared/GWTBridge/invoke/bpm/bpmMain';
import {BpmAlertResponse, GWTMetaData, GWTRulesType} from './types';
import {buildServerCall} from '../../../../../services/wcfService';
import {handleBPMMessages} from '../utils/handlePermission';
import {bpmRulesStorage} from '../BPM.rules.storage';

export const bpmChangeRuleOrder = async (
    alerts: Array<{alert: string}>,
    fromStatus: string,
    toStatus: string = '0'
) => {
    const methodName = 'BPMAlertOrder';
    const reason = 'BPMAlertOrder';

    const fromId = getStatusID(fromStatus)?.toString();
    const toId = getStatusID(toStatus)?.toString();

    const data = {
        Rules: {
            Alert: {
                type: GWTRulesType.BPMStatusRules,
                id1: fromId,
                id2: toId
            },
            Rule: alerts
        }
    };

    const xml = window['common'].compressString(js2xml(data, {compact: true}));

    const parameters = {
        session: [getCurSession()],
        xml: [xml]
    };

    const res: BpmAlertResponse = await buildServerCall(
        methodName,
        parameters,
        reason,
        true,
        getConnection
    );

    const BPM = res?.BPM?.[0];
    const isOk = await handleBPMMessages(BPM as GWTMetaData);

    if (isOk) {
        // Triggers GWT state change flag
        setIsBPMChanged(true);

        const storageData = bpmRulesStorage.getStorage(getCurSession());
        const data = storageData.getRules(fromId, toId);

        if (data) {
            const orderedData = alerts
                .map(item => data.find(element => element.alert.toString() === item.alert))
                .filter(Boolean);

            storageData.setRules(fromId, toId, orderedData);
        }
    }
    return isOk;
};
